import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { HttpResponseService } from '../../../../core/services/http-error-response.service';
import { ReportsApi } from '../../../../shared/services/api/reports.api';
import { DictionaryItemDto } from '../../../../shared/models/raport';

export const applicationTypesResolver: ResolveFn<DictionaryItemDto[]> = (
  route,
) => {
  const api = inject(ReportsApi);
  const httpResponseService = inject(HttpResponseService);

  return api.getTypesDictionary$().pipe(
    catchError((err) => {
      httpResponseService.showErrorMessage(
        err,
        'Wystąpił błąd podczas pobierania danych słownika.',
      );
      return EMPTY;
    }),
  );
};
